import { HubConnection, HubConnectionState } from '@microsoft/signalr'
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useSignalRStore = defineStore('pinia/signalr', () => {
  const orgConnection = ref<HubConnection>()
  const userConnection = ref<HubConnection>()
  const handlersRegistered = ref(false)
  const isIntentionalDisconnect = ref(false)

  const updateOrgConnection = (connection: HubConnection) => {
    orgConnection.value = connection
  }

  const updateUserConnection = (connection: HubConnection) => {
    userConnection.value = connection
  }

  const isOrgConnected = computed(
    () => orgConnection.value?.state === HubConnectionState.Connected,
  )
  const isUserConnected = computed(
    () => userConnection.value?.state === HubConnectionState.Connected,
  )
  const isOrgDisconnected = computed(
    () =>
      orgConnection.value?.state === HubConnectionState.Disconnected ||
      !orgConnection.value,
  )
  const isUserDisconnected = computed(
    () =>
      userConnection.value?.state === HubConnectionState.Disconnected ||
      !userConnection.value,
  )
  const isOrgDisconnecting = computed(
    () => orgConnection.value?.state === HubConnectionState.Disconnecting,
  )
  const isUserDisconnecting = computed(
    () => userConnection.value?.state === HubConnectionState.Disconnecting,
  )

  return {
    orgConnection,
    userConnection,
    handlersRegistered,
    isIntentionalDisconnect,
    updateOrgConnection,
    updateUserConnection,
    isOrgConnected,
    isUserConnected,
    isOrgDisconnected,
    isUserDisconnected,
    isOrgDisconnecting,
    isUserDisconnecting,
  }
})
